import { Popup } from 'popup/popup.module';

import { getFontSetting, isMobileOrTablet, setCustomTagHTML } from 'helpers/helpers';
import { socketInit } from 'helpers/socket';
import { ENGT_CHAT } from 'js/bot.model';
import { appendInitTimeStamp } from 'js/conversation';

import { setLocalizedString } from '../../index';
import { AppTemplate } from './app.template';

export const AppComponent = {
	async init() {
		this.appElement = document.body;
		await this.initData();
		await this.initWrapper();
		await this.initComponents();

		await this.render();
		await setLocalizedString();

		this.initSocket();
		this.initConversation();
	},

	initData() {
		this.data = {};
	},

	initWrapper() {
		const wrapper = document.createElement('section');

		wrapper.classList.add('engt', 'engt-standalone', `engt-font-${getFontSetting()}`);
		wrapper.innerHTML = AppTemplate(this.data);
		if (isMobileOrTablet()) {
			wrapper.classList.add('engt-mobile-tab');
		}

		this.html = wrapper;
	},

	initComponents() {
		const popupWindow = new Popup().render();

		setCustomTagHTML(this.html.querySelector('pop-up'), popupWindow);
	},

	initSocket() {
		socketInit();
	},

	initConversation() {
		appendInitTimeStamp();
		ENGT_CHAT.get('showChatScreen')();
	},

	setter(propData) {
		this.data = {
			...this.data,
			...propData,
		};
	},

	render() {
		this.appElement.appendChild(this.html);
	},
};
